<template>
  <div
    class="tree__entry"
    :class="{ 'is-top-level': isTopLevel, 'is-child': isChild }"
    @click="node.children.length ? onclick() : onchange(!checked)"
  >
    <FormCheckbox
      class="tree__checkbox"
      :value="checked"
      :indeterminate="indeterminate"
      :label="node.title || node.value"
      :sublabel="node.subtitle"
      @input="onchange"
      @click.native.stop
      size="small"
    />
    <template v-if="node.children && node.children.length && !isTopLevel">
      <BaseTag v-if="node.language" tone="neutral" preset="soft">
        {{ $t(`languages.short-${node.language}`) }}
      </BaseTag>
      <BaseIcon name="chevron-right" class="entry__action" @click.native="onclick" />
    </template>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';
import BaseTag from '@/components/base/BaseTag.vue';
import FormCheckbox from '@/components/form/FormCheckbox';
import { Node } from './tree-parser';
import { indeterminate, checked } from './recursive-utils';

export default {
  name: 'node',
  components: {
    BaseIcon,
    BaseTag,
    FormCheckbox,
  },
  props: {
    node: Node,
    isTopLevel: Boolean,
  },
  computed: {
    checked() {
      return checked(this.node);
    },
    indeterminate() {
      return indeterminate(this.node);
    },
    isChild() {
      return !this.node.children.length > 0;
    },
  },
  methods: {
    onclick() {
      this.$emit('onclick', this.node);
    },
    onchange(value) {
      this.$emit('onchange', { value, node: this.node });
    },
  },
};
</script>

<style lang="scss">
.tree {
  padding-top: 28px;

  &__entry {
    padding: 16px;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    flex-grow: 1;
    width: 100%;
    cursor: pointer;

    &:last-of-type {
      padding-bottom: 16px;
    }

    &.is-child {
      padding: 8px !important;
    }

    .form-checkbox__text-container {
      color: $color-normal;
      font-family: $font-families;
      margin-left: 12px;

      .label__text {
        font-size: 14px;
        font-weight: normal;
      }

      .label__subtext {
        font-size: $font-size-xsmall;
        font-style: italic;
      }
    }

    .form-checkbox__input.is-checked + .form-checkbox__label {
      .form-checkbox__text-container {
        .label__text {
          font-weight: bold;
        }
      }
    }

    &.is-child {
      .label__text {
        font-size: $font-size-small;
        font-weight: normal;
        display: flex;

        &::before {
          content: '➞';
          color: $color-accent;
          display: block;
          flex: none;
          font-size: $font-size-small;
          margin-right: 8px;
        }
      }
    }

    &.is-top-level {
      width: 240px !important;
      margin-right: 8px;
      flex-grow: 0;
      padding: 16px 0;
      cursor: default;

      &:hover {
        background: $color-white;
      }
    }

    &.is-selected {
      color: $color-accent;
      background: $color-neutral-pale;

      .form-checkbox__text-container {
        color: $color-accent;
      }
    }

    &:hover {
      background: $color-neutral-pale;
    }
  }

  &__checkbox {
    position: relative;
    display: flex;
    flex-grow: 1;
    max-width: 500px;
  }
}
</style>
